import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import { localApi, credentials } from "utils/imgApi";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import EmailIcon from "@material-ui/icons/Email";
import Select from "@material-ui/core/Select";
import PublicIcon from "@material-ui/icons/Public";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Face from "@material-ui/icons/Face";
import BusinessIcon from "@material-ui/icons/Business";
import Check from "@material-ui/icons/Check";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styl from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { getStates, getCities } from "utils/util";
import axios from "axios";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyl = makeStyles(styl);

export default function RegisterPage() {
  const [countryList, setCountryList] = React.useState([]);
  const [firstName, setFirstName] = React.useState("");
  const [firstNameErr, setFirstNameErr] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [lastNameErr, setLastNameErr] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [mobileWhatsapp, setMobileWhatsapp] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [companyErr, setCompanyErr] = React.useState("");
  const [countryCode, setCountryCode] = React.useState("in");
  const [countryName, setCountryName] = React.useState("India");
  const [cityErr, setCityErr] = React.useState("");
  const [stateCode, setStateCode] = React.useState("");
  const [stateNameErr, setStateNameErr] = React.useState("");
  const [active, setActive] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [checkboxValue, setCheckboxValue] = React.useState(false);
  const [alertType, alertTypeOps] = useState("");
  const [alertMsg, alertMsgOps] = useState("");
  const [stateSelect, setStateSelect] = React.useState("");
  const [citySelect, setCitySelect] = React.useState("");
  const [webSelect, setWebSelect] = React.useState("");
  const [webSelectErr, setWebSelectErr] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [type, setType] = React.useState("");
  const [domain, setDomain] = React.useState("");
  const [domainErr, setDomainErr] = React.useState("");
  const [btn, setBtn] = React.useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState("razorpay"); // default
  const [regUserData, setRegUserData] = React.useState("");

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = React.useState("");
  const inputs = useRef([]);

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
  }, []);

  const classes = useStyles();
  const classe = useStyle();
  const classDrop = useStyl();
  const history = useHistory();

  const currentSession = sessionStorage.getItem("sessionData");
  if (currentSession) {
    history.push("/admin/dashboard");
  }

  const { state } = useLocation();

  // async function fetchCountryListCode() {
  //   const api = localApi + `/countrylistcode/allList`;
  //   const result = await fetch(api);
  //   const getResult = await result.json();
  //   setCountryList(getResult);
  // }

  // useEffect(() => {
  //   fetchCountryListCode();
  // }, []);

  async function getUser() {
    const api = localApi + `/type/list`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.filter((item) => item.title !== "Admin"));
    // setType(getResult.LoginType.filter((item) => item.title !== "Admin"));
    setType(getResult && getResult.TypeList);
    // console.log(getResult);
  }

  useEffect(() => {
    getUser();
  }, []);

  const handleMobileNumber = (mobile) => {
    setMobile(mobile);
    fetch(localApi + `/admin/find/byMobile/${mobile}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);
          if (result.message === "Not Found") {
            setMobileErr("")
          } else {
            setMobileErr(result.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
    fetch(localApi + `/admin/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);
          if (result.message === "Not Found") {
            setEmailErr("")
          } else {
            setEmailErr(result.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleDomain = (e) => {
    const { value } = e.target;
    setDomain(value);
    setDomainErr("");
  };

  const handleCheckedBox = (e) => {
    // console.log(checkboxValue);
    if (e.target?.checked) {
      setMobileWhatsapp(mobile);
    } else {
      setMobileWhatsapp("");
    }
    setCheckboxValue(e.target.checked);
  };

  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      // Move to next input if a number was entered
      if (text && index < 5) {
        inputs.current[index + 1].current.focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && password[index] === "" && index > 0) {
      inputs.current[index - 1].current.focus();
    }
  };

  const handleState = (event) => {
    setStateSelect(event.target.value);
    setStateNameErr("");
  };

  const handleCity = (event) => {
    setCitySelect(event.target.value);
    setCityErr("");
  };

  const handleWeb = (event) => {
    setWebSelect(event.target.value);
    setWebSelectErr("");
  };

  const loadCashfree = () =>
    new Promise((resolve, reject) => {
      if (window.Cashfree && typeof window.Cashfree === "function") {
        return resolve();
      }

      const script = document.createElement("script");
      script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
      script.onload = () => resolve();
      script.onerror = () => reject(new Error("Failed to load Cashfree SDK"));
      document.head.appendChild(script);
    });

  const SubmitBasic = async () => {
    try {
      // Validation check variables
      let errorCount = 0;
      let errorFields = []; // 👈 Track fields with errors

      const getFind = type.find((f) => f.title === "Admin");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      const intValue = parseInt(state.price.replace(/,/g, ""), 10);

      const FreeDate = new Date();
      FreeDate.setMonth(FreeDate.getMonth() + 3);

      const BasicDate = new Date();
      BasicDate.setFullYear(BasicDate.getFullYear() + 1);
      const passwordString = password.join("");
      // console.log(passwordString);


      // === Basic Form Validations ===
      if (!firstName) {
        setFirstNameErr("Please Enter First Name");
        errorCount++;
        errorFields.push("firstName");
      }
      if (!lastName) {
        setLastNameErr("Please Enter Last Name");
        errorCount++;
        errorFields.push("lastname");
      }
      if (!mobile || !isValidPhoneNumber(`+${mobile}`)) {
        setMobileErr("Please Enter Valid Mobile Number");
        errorCount++;
        errorFields.push("mobile");
      }
      if (!email || !emailRegex.test(email)) {
        setEmailErr("Please Enter Valid Email");
        errorCount++;
        errorFields.push("email");
      }
      if (!passwordString || passwordString.length !== 6) {
        setPasswordErr("mPIN must be exactly 6 digits.");
        errorCount++;
        errorFields.push("password");
      }
      if (!company) {
        setCompanyErr("Please Enter Company Name");
        errorCount++;
        errorFields.push("company");
      }
      if (!domain) {
        setDomainErr("Please Enter Domain");
        errorCount++;
        errorFields.push("domain");
      }
      if (!citySelect) {
        setCityErr("Please Select City");
        errorCount++;
        errorFields.push("city");
      }
      if (!stateSelect) {
        setStateNameErr("Please Select State");
        errorCount++;
        errorFields.push("state");
      }

      // === Duplicate Mobile/Email Checks ===
      if (mobileErr === "Mobile Already Registered") {
        errorCount++;
        alertTypeOps("danger");
        alertMsgOps("Number already registered");
        setSubmitted(true);
      }

      if (emailErr === "Email Id Already Registered") {
        errorCount++;
        alertTypeOps("danger");
        alertMsgOps("Email already registered");
        setSubmitted(true);
      }

      if (errorCount > 0) {
        // console.log("Validation failed. Errors:", errorCount);
        // console.log("Missing/Invalid fields:", errorFields);
        return;
      }

      const userData = {
        websitename: domain,
        endDate: state.price === "0" ? FreeDate : BasicDate,
        webPlan: state.title,
        typeId: getFind.typeId,
        profit: getFind.profit,
        type: "Admin",
        firstname: firstName,
        lastname: lastName,
        mobile: mobile,
        whatsapp: mobileWhatsapp,
        email: email,
        password: passwordString,
        company: company,
        city: citySelect.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
        state: stateSelect.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
        country: countryName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
        smsMarketing: active,
        otp: { otp: 0, active: 0 },
      };

      setRegUserData(userData)

      if (state.price === "0") {
        // console.log("0"); // ✅ Free Plan log
        const response = await axios.post(`${localApi}/admin/find/byMobile&Email/add`, userData, {
          headers: { Authorization: `Basic ${credentials}` },
        });

        const message = response.data.message;
        // console.log("Message:", message); // ✅ Response message log

        if (message === "Data Inserted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Successfully registered!");
          setSubmitted(true);
        } else {
          alertTypeOps("danger");
          alertMsgOps("Something went wrong!");
        }

      } else {
        if (selectedPaymentMethod === "razorpay") {
          // === Create Razorpay Order ===
          const orderResponse = await fetch(`${localApi}/payment/create-order`, {
            method: 'POST',
            headers: {
              Authorization: `Basic ${credentials}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              amount: intValue * 100,
              currency: 'INR',
              receipt: 'receipt_001',
            }),
          });

          const orderData = await orderResponse.json();
          // console.log("Order Data:", orderData);

          if (!orderData || !orderData.order_id) {
            alertTypeOps("danger");
            alertMsgOps("Failed to create Razorpay order");
            return;
          }

          const options = {
            key: "rzp_live_C725eH28zc3GKC",
            amount: intValue * 100,
            currency: "INR",
            name: "INDIAN BANGLES (Manufacture)",
            description: " (Manufacture)",
            // image: "https://i.imgur.com/3g7nmJC.jpg",
            order_id: orderData.order_id,
            prefill: {
              name: `${firstName} ${lastName}`,
              email: email,
              contact: mobile,
            },
            // theme: { color: "#53a20e" },
            handler: async function (response) {
              // console.log("Razorpay Payment Response:", response);

              if (response.razorpay_payment_id) {
                const paidUserRes = await axios.post(
                  `${localApi}/admin/find/byMobile&Email/add`,
                  userData,
                  {
                    headers: { Authorization: `Basic ${credentials}` },
                  }
                );

                const message = paidUserRes.data.message;
                // console.log("Paid user registration message:", message);

                if (message === "Data Inserted Successfully !!!") {
                  alertTypeOps("success");
                  alertMsgOps("Successfully registered!");
                  setSubmitted(true);
                } else {
                  alertTypeOps("danger");
                  alertMsgOps("Something went wrong!");
                }
              }
            },
            modal: {
              ondismiss: function () {
                console.log("Payment popup closed by user");
              },
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();
        } else if (selectedPaymentMethod === "cashfree") {
          try {
            await loadCashfree();
            const custId = `CID_${Date.now()}`;
            const response = await fetch(
              `${localApi}/payment/createCashFreeOrder`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Basic ${credentials}`,
                },
                body: JSON.stringify({
                  orderAmount: intValue,
                  customerId: custId,
                  customerName: firstName + "" + lastName,
                  customerEmail: email,
                  customerPhone: mobile,
                  returnUrl: "https://admin.indianbangles.in/auth/register-page",
                }),
              }
            );

            if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`Server error ${response.status}: ${errorText}`);
            }

            const data = await response.json();
            console.log("Order Response:", data);

            const paymentSessionId = data.paymentSessionId || data.payment_session_id;

            if (!paymentSessionId) {
              alert("Payment session ID is missing.");
              console.error("Invalid response:", data);
              return;
            }

            const cashfree = window.Cashfree({ mode: "production" });

            await cashfree.checkout({
              paymentSessionId,
              redirectTarget: "_self",
              // returnUrl: `https://admin.indianbangles.in/auth/login-page`,
              returnUrl: window.location.href, // Return to same page
            });

            // const paidUserRes = await axios.post(
            //   `${localApi}/admin/find/byMobile&Email/add`,
            //   userData,
            //   {
            //     headers: { Authorization: `Basic ${credentials}` },
            //   }
            // );

            // const message = paidUserRes.data.message;
            // // console.log("Paid user registration message:", message);

            // if (message === "Data Inserted Successfully !!!") {
            //   alertTypeOps("success");
            //   alertMsgOps("Successfully registered!");
            //   setSubmitted(true);
            // } else {
            //   alertTypeOps("danger");
            //   alertMsgOps("Something went wrong!");
            // }

          } catch (error) {
            console.error("Payment error:", error);
            alert("Something went wrong during payment.");
          }
        }
      }
    } catch (error) {
      console.error("Signup error:", error);
      alertTypeOps("danger");
      alertMsgOps("Failed to sign up. Please try again later.");
    }
  };

  useEffect(() => {
    const checkCashfreeReturn = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const orderId = urlParams.get("order_id");
      const status = urlParams.get("txStatus");

      if (orderId && status === "SUCCESS") {
        console.log("Detected successful return from Cashfree:", { orderId });

        try {
          const paidUserRes = await axios.post(
            `${localApi}/admin/find/byMobile&Email/add`,
            regUserData,
            {
              headers: { Authorization: `Basic ${credentials}` },
            }
          );

          const message = paidUserRes.data.message;

          if (message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Successfully registered!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Something went wrong!");
          }
        } catch (error) {
          console.error("Error during Cashfree success registration:", error);
          alertTypeOps("danger");
          alertMsgOps("Registration failed after payment. Please contact support.");
        }
      }
    };

    checkCashfreeReturn();
  }, []);


  const hideAlert = () => {
    setSubmitted(false);
    // history.push("/auth/login-page");
    if (!mobileErr || mobileErr === "") {
      if (!emailErr || emailErr === "") {
        history.push("/auth/login-page");
      }
    }
  };

  const mystyle = {
    paddingLeft: 12,
    flex: 1,
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "10px",
    marginLeft: "25px"
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={10} md={6}>
          <Card className={classes.cardSignup}>
            <h2 className={classes.cardTitle}>Admin Register</h2>
            <CardBody>
              <GridContainer justify="center">
                <GridItem xs={12} sm={10} md={8}>
                  <div className={classes.center}>
                    <Button justIcon round color="twitter">
                      <i className="fab fa-twitter" />
                    </Button>
                    {` `}
                    <Button justIcon round color="dribbble">
                      <i className="fab fa-dribbble" />
                    </Button>
                    {` `}
                    <Button justIcon round color="facebook">
                      <i className="fab fa-facebook-f" />
                    </Button>
                    {` `}
                    <h4 className={classes.socialTitle}>or be classical</h4>
                  </div>

                  <form className={classes.form}>
                    {submitted ? (
                      <SweetAlert
                        type={alertType}
                        style={{ display: "block", marginTop: "-100px" }}
                        title={alertMsg}
                        onConfirm={() => hideAlert()}
                        confirmBtnCssClass={
                          classe.button + " " + classe.success
                        }
                      />
                    ) : null}

                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "First Name...",
                      }}
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                        setFirstNameErr("");
                      }}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {firstNameErr}
                    </span>
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "Last Name...",
                      }}
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                        setLastNameErr("");
                      }}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {lastNameErr}
                    </span>

                    <br />
                    <PhoneInput
                      style={mystyle}
                      inputStyle={{
                        width: "105%",
                        border: "none",
                        borderBottom: "1px solid #040000",
                        borderRadius: "0",
                      }}
                      country={"in"}
                      name="mobile"
                      value={mobile}
                      onChange={(mobile) => {
                        let country_code = document.body.querySelector(
                          "div.flag"
                        )?.className;
                        country_code =
                          country_code && country_code.replace("flag", "");
                        setCountryCode(country_code.trim());
                        // console.log(country_code);
                        handleMobileNumber(mobile);
                        let country_name = document.body.querySelector(
                          "div.selected-flag"
                        )?.title;
                        setCountryName(country_name.slice(0, -6));
                      }}
                      // onChange={(mobile) => {
                      //   setMobile(mobile.length <= 12 ? mobile : mobile);
                      // setMobileErr("");
                      // }}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {mobileErr}
                    </span>
                    <br />
                    <FormControlLabel
                      classes={{
                        root: classes.checkboxLabelControl,
                        label: classes.checkboxLabel,
                      }}
                      control={
                        <Checkbox
                          // id="active"
                          checked={checkboxValue || false}
                          onChange={(e) => handleCheckedBox(e)}
                          tabIndex={-1}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      label={
                        <span style={{ color: "#9c27b0" }}>
                          If your WhatsApp Number is same, click on this
                          checkbox.
                        </span>
                      }
                    />
                    <br />
                    <PhoneInput
                      style={mystyle}
                      inputStyle={{
                        width: "105%",
                        border: "none",
                        borderBottom: "1px solid #040000 ",
                        borderRadius: "0",
                      }}
                      country={"in"}
                      name="mobile"
                      value={mobileWhatsapp}
                      onChange={(mobileWhatsapp) => {
                        if (mobile === mobileWhatsapp) {
                          setCheckboxValue(true);
                        } else {
                          setCheckboxValue(false);
                        }
                        setMobileWhatsapp(mobileWhatsapp);
                        // setMobileWhatsappErr("");
                      }}
                    // required={true}
                    />
                    {/* <span style={{ color: "red" }}>{mobileWhatsappErr}</span> */}

                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <BusinessIcon
                              className={classes.inputAdornmentIcon}
                            />
                          </InputAdornment>
                        ),
                        placeholder: "Company...",
                      }}
                      id="company"
                      name="company"
                      value={company}
                      onChange={(e) => {
                        setCompany(e.target.value);
                        setCompanyErr("");
                      }}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {companyErr}
                    </span>

                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <EmailIcon className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: "Email...",
                      }}
                      id="email"
                      name="email"
                      value={email}
                      onChange={handleEmail}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {emailErr}
                    </span>

                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <PublicIcon
                              className={classes.inputAdornmentIcon}
                            />
                          </InputAdornment>
                        ),
                        placeholder: "Domain...",
                      }}
                      id="domain"
                      name="domain"
                      value={domain}
                      onChange={handleDomain}
                      required={true}
                    />
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {domainErr}
                    </span>

                    <GridItem style={{ width: "110%" }}>
                      <FormControl
                        fullWidth
                        className={classDrop.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classDrop.selectLabel}
                        >
                          Select State...
                        </InputLabel>

                        <Select
                          MenuProps={{
                            className: classDrop.selectMenu,
                          }}
                          classes={{
                            select: classDrop.select,
                          }}
                          value={stateSelect}
                          onChange={handleState}
                          required={true}
                          inputProps={{
                            name: "stateSelect",
                            id: "simple-select",
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classDrop.selectMenuItem,
                            }}
                          >
                            Select State
                          </MenuItem>
                          {getStates(countryCode).map((item) => (
                            <MenuItem
                              key={item.name}
                              value={item.name}
                              onClick={() => setStateCode(item?.state_code)}
                              classes={{
                                root: classDrop.selectMenuItem,
                                selected: classDrop.selectMenuItemSelected,
                              }}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <span style={{ color: "red" }}>{stateNameErr}</span>
                    </GridItem>

                    <GridItem style={{ width: "110%" }}>
                      <FormControl
                        fullWidth
                        className={classDrop.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classDrop.selectLabel}
                        >
                          Select City...
                        </InputLabel>

                        <Select
                          MenuProps={{
                            className: classDrop.selectMenu,
                          }}
                          classes={{
                            select: classDrop.select,
                          }}
                          value={citySelect}
                          onChange={handleCity}
                          required={true}
                          inputProps={{
                            name: "stateSelect",
                            id: "simple-select",
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classDrop.selectMenuItem,
                            }}
                          >
                            Select City
                          </MenuItem>
                          {getCities(countryCode, stateCode).map((item) => (
                            <MenuItem
                              key={item.name}
                              value={item.name}
                              classes={{
                                root: classDrop.selectMenuItem,
                                selected: classDrop.selectMenuItemSelected,
                              }}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <span style={{ color: "red" }}>{cityErr}</span>
                    </GridItem>
                    <label style={{ marginLeft: "20px", marginTop: "20px" }}>mPIN</label>
                    <div style={containerDigit}>
                      {password.map((digit, index) => (
                        <input
                          key={index}
                          ref={inputs.current[index]}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => {
                            handlePasswordChange(e.target.value, index)
                            setPasswordErr("")
                          }}
                          onKeyDown={(e) => handleKeyPress(e, index)}
                          style={inputDigit}
                        />
                      ))}
                    </div>
                    <span style={{ color: "red", marginLeft: "12px" }}>
                      {passwordErr}
                    </span>
                    <br />

                    <FormControlLabel
                      classes={{
                        root: classes.checkboxLabelControl,
                        label: classes.checkboxLabel,
                      }}
                      control={
                        <Checkbox
                          id="active"
                          value={active}
                          onChange={(e) => {
                            setActive(e.target.checked);
                          }}
                          tabIndex={-1}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      label={
                        <span style={{ color: "#9c27b0", fontSize: "12px" }}>
                          I would like to recieve the latest news from the
                          Company by phone/whatsapp
                        </span>
                      }
                    />
                  </form>
                  <div>
                    <h4>Package Information</h4>
                    <div className={classes.center}>
                      {state ? (
                        <h5
                          // size={18}
                          style={{ color: "#9c27b0", textAlign: "center" }}
                        >
                          Account:- {state.title}
                          <br />
                          Hosting Price:- {"₹ " + state.price + "/-"}
                          {" (" + state.month + ")"}
                        </h5>
                      ) : (
                        ""
                      )}

                      {/* {state === "3600" ? (
                        <GridContainer justify="center">
                          <GridItem style={{ width: "80%" }}>
                            <FormControl
                              fullWidth
                              className={classDrop.selectFormControl}
                            >
                              <InputLabel
                                htmlFor="simple-select"
                                className={classDrop.selectLabel}
                              >
                                Select Account Plan...
                              </InputLabel>

                              <Select
                                MenuProps={{
                                  className: classDrop.selectMenu,
                                }}
                                classes={{
                                  select: classDrop.select,
                                }}
                                value={webSelect}
                                onChange={handleWeb}
                                required={true}
                                inputProps={{
                                  name: "stateSelect",
                                  id: "simple-select",
                                }}
                              >
                                <MenuItem
                                  disabled
                                  classes={{
                                    root: classDrop.selectMenuItem,
                                  }}
                                >
                                  Select Account Plan
                                </MenuItem>
                                <MenuItem
                                  classes={{
                                    root: classDrop.selectMenuItem,
                                    selected: classDrop.selectMenuItemSelected,
                                  }}
                                  value="FREE PLAN"
                                >
                                  FREE BASIC PLAN 3 MONTHS
                                </MenuItem>
                                <MenuItem
                                  classes={{
                                    root: classDrop.selectMenuItem,
                                    selected: classDrop.selectMenuItemSelected,
                                  }}
                                  value="12 MONTHS"
                                >
                                  BASIC SHARED PLAN 12 MONTHS
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <span style={{ color: "red" }}>{webSelectErr}</span>
                          </GridItem>
                        </GridContainer>
                      ) : (
                        ""
                      )}
                      {state === "3600" ? (
                        webSelect ? (
                          <h5 style={{ color: "#9c27b0" }}>
                            Account:-{" "}
                            {webSelect === "FREE PLAN"
                              ? "FREE BASIC PLAN"
                              : "BASIC SHARED PLAN"}
                            <br />
                            Hosting Price:-{" "}
                            {webSelect === "FREE PLAN"
                              ? "₹ 0/- (3 Months)"
                              : "₹ 3,600/- (12 Months)"}
                          </h5>
                        ) : (
                          ""
                        )
                      ) : state === "59828" ? (
                        <h5 style={{ color: "#9c27b0" }}>
                          Account:- Advanced Shared Plan
                          <br />
                          Hosting Price:- ₹ 59,828/- (12 Months)
                        </h5>
                      ) : state === "69828" ? (
                        <h5 style={{ color: "#9c27b0" }}>
                          Account:- Standard Shared Plan
                          <br />
                          Hosting Price:- ₹ 69,828/- (12 Months)
                        </h5>
                      ) : state === "118228" ? (
                        <h5 style={{ color: "#9c27b0" }}>
                          Account:- Customized Shared Plan
                          <br />
                          Hosting Price:- ₹ 1,18,228/- (12 Months)
                        </h5>
                      ) : (
                        ""
                      )} */}
                    </div>
                  </div>
                  <div className={classes.center}>
                    {/* <Button round color="primary" onClick={Submit}>
                      Sign Up
                    </Button> */}
                    {/* <Button color="rose" onClick={test}>
                      test
                    </Button> */}
                    {/* {btn === true ? (
                      <Button round>Sign Up</Button>
                    ) : (
                      <Button color="rose" onClick={SubmitBasic} round>
                        Sign Up
                      </Button>
                    )} */}
                    {state.price !== "0" && (
                      <div style={{ marginBottom: "15px" }}>
                        <h4 style={{ fontSize: "18px", fontWeight: "bold" }}>
                          Select Payment Method:
                        </h4>

                        <label style={{ fontSize: "16px", marginRight: "20px", color: "#9c27b0" }}>
                          <input
                            type="radio"
                            value="razorpay"
                            checked={selectedPaymentMethod === "razorpay"}
                            onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                            style={{ marginRight: "5px" }}
                          />
                          Razorpay
                        </label>

                        <label style={{ fontSize: "16px", color: "#9c27b0" }}>
                          <input
                            type="radio"
                            value="cashfree"
                            checked={selectedPaymentMethod === "cashfree"}
                            onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                            style={{ marginRight: "5px" }}
                          />
                          Cashfree
                        </label>
                      </div>
                    )}
                    <Button
                      color="rose"
                      onClick={SubmitBasic}
                      round
                    // disabled={btn}
                    >
                      Sign Up
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

    </div>
  );
}
